import { useState, useEffect } from "react";
import axios from "axios";
import useAxiosConfig from "../../../config/useAxiosConfig";

const useSchoolDropdown = () => {
  const { loading: axiosLoading, error, postData: apiPost } = useAxiosConfig();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get("/AdminSchoolsCollection");
        setData(response.data?.rows || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    if (!axiosLoading) {
      fetchData();
    }
  }, [axiosLoading]);

  return {
    data,
    loading,
  };
};

export default useSchoolDropdown;
